/**
 * APIレスポンスのステータス
 */
export enum Status {
  /**
   * 正常
   */
  Success = 'success',
  /**
   * タイムアウト
   */
  Timeout = 'timeout',
  /**
   * 内部エラー
   */
  InternalError = 'internalError',
  /**
   * バリデーションエラー
   */
  ValidateError = 'validateError',
  /**
   * 該当ユーザー無し
   */
  NotFoundConnector = 'notFoundConnector',
  /**
   * 範囲外エラー
   */
  OutOfRange = 'outOfRange',
  /**
   * 紹介ポジション該当なし
   */
  NotFoundInvitePosition = 'notFoundInvitePosition',
  /**
   * 法人証明書が見つからない
   */
  NotFoundCompanyLicense = 'notFoundCompanyLicense',
  /**
   * 登録済み
   */
  AlreadyRegistered = 'alreadyRegistered',
  /**
   * ポジション未契約
   */
  NotFoundPosition = 'notFoundPosition',
  /**
   * ATEMクエストID重複
   */
  DuplicateAtemQuestId = 'duplicateAtemQuestId',
  /**
   * 契約不可能ポジションナンバー
   */
  InvalidPositionNumber = 'invalidPositionNumber',
  /**
   * 契約済み
   */
  AlreadyContracted = 'alreadyContracted',
  /**
   * 名義変更不可
   */
  CantPositionAssignment = 'cantPositionAssignment',

  /**
   * パナシアペイ口座作成失敗
   */
  PanaceaPayFailure = 'panaceaPayFailure',
  /**
   * TRUSTDOCK API失敗
   */
  TrustDockFailure = 'trustDockFailure',

  /**
   * バイナリマップが存在しない
   */
  NotFoundBinaryMap = 'notFoundBinaryMap',

  /**
   * 報酬明細が見つからない
   */
  NotFoundReward = 'notFoundReward',
  /**
   * 報酬明細が非公開
   */
  PrivateReward = 'privateReward',
}
